var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccountMenuKey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "keys-icon",
    transform: "translate(-1407 -2684)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4791",
    "data-name": "Rectangle 4791",
    width: 24,
    height: 24,
    transform: "translate(1407 2684)",
    fill: "rgba(255,255,255,0)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "icons_Toothbrush_Line",
    "data-name": "icons/Toothbrush/Line",
    transform: "translate(1410.906 2686.706)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M9.45.669A2.284,2.284,0,0,1,12.68,3.9L3.9,12.68A2.284,2.284,0,1,1,.669,9.45Zm2.2,1.035a.821.821,0,0,0-1.16,0L1.7,10.485a.821.821,0,0,0,1.16,1.16l8.781-8.781A.821.821,0,0,0,11.645,1.7Z",
    transform: "translate(2.838 2.107)",
    fill: "#6b6b95"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Shape-2",
    "data-name": "Shape",
    transform: "translate(6.586)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_56254313-CF60-41E2-8CAE-B228779D1FAF",
    "data-name": "56254313-CF60-41E2-8CAE-B228779D1FAF",
    d: "M.214.214a.732.732,0,0,1,1.035,0l2.2,2.2A.732.732,0,0,1,2.41,3.444l-2.2-2.2A.732.732,0,0,1,.214.214Z",
    transform: "translate(3.659)",
    fill: "#6b6b95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "D615BB5F-4C80-4445-8A0D-1323E0C7437F",
    d: "M.214.214a.732.732,0,0,1,1.035,0L3.079,2.044A.732.732,0,0,1,2.044,3.079L.214,1.249A.732.732,0,0,1,.214.214Z",
    transform: "translate(2.195 2.195)",
    fill: "#6b6b95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_6D94E5E4-18AD-4CCF-BFB2-5FD1091F2181",
    "data-name": "6D94E5E4-18AD-4CCF-BFB2-5FD1091F2181",
    d: "M1.249.214A.732.732,0,0,0,.214,1.249l2.2,2.2A.732.732,0,0,0,3.444,2.41Z",
    transform: "translate(0 3.659)",
    fill: "#6b6b95"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Shape-3",
    "data-name": "Shape",
    d: "M5.122,8.781A3.659,3.659,0,1,0,1.464,5.122,3.659,3.659,0,0,0,5.122,8.781Zm0,1.464A5.122,5.122,0,1,0,0,5.122,5.122,5.122,0,0,0,5.122,10.245Z",
    transform: "translate(0 8.049)",
    fill: "#6b6b95"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1662",
    "data-name": "Ellipse 1662",
    transform: "translate(1.464 9.513)",
    fill: "#fbfcfb",
    stroke: "#fff",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3.659,
    cy: 3.659,
    r: 3.659,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.659,
    cy: 3.659,
    r: 3.159,
    fill: "none"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountMenuKey);
export default __webpack_public_path__ + "static/media/accountMenuKey.875029cc28a74ab27b231052312306de.svg";
export { ForwardRef as ReactComponent };